export class RuntimeAssertError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RuntimeAssertError';
    }
}
// NOTE: This is an old-fashioned function as TypeScript does not support calling `asserts`
// arrow functions.
export function assertNever(condition, message) {
    if (!condition) {
        throw new RuntimeAssertError(message);
    }
}
